import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpParams} from  '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class WizardService {
  API_URL  =  'http://localhost:3030';
  CORE_API_URL  =  'http://localhost:3033';
  
  constructor(private  httpClient:  HttpClient) {
    
    /*let fullURL=window.location;
    let strFullURL=fullURL.toString().toLowerCase();
    let https=false;
    if(strFullURL.indexOf("https://")!=-1)
      https=true;
    strFullURL=strFullURL.replace("https://","");
    strFullURL=strFullURL.replace("http://","");
    let idx=strFullURL.indexOf("/");
    if(https)
      this.API_URL="https://"+strFullURL.substr(0,idx);
    else
      this.API_URL="http://"+strFullURL.substr(0,idx);  */
  }
  
  testDatabase(config:object)  {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"testDatabase",data:config},{headers});
    
    return ret;
  }
  
  testDependency(config:object)  {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"testDependency",data:config},{headers});
    
    return ret;
  }
  
  finishWizard(config:object){
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"finishWizard",data:config},{headers});
    
    return ret;
  }
  
  getCurrentConfig()
  {
    console.log("getCurrentConfig called:"+this.API_URL);
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"getConfig"},{headers});
    
    return ret;
  }
  
  testRunWizard()
  {
    const config={
      
      
    };
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"finishWizard",data:config},{headers});
    return ret;
  }
  
  testCreateFolder()
  {
    const config={
      path: '/etc/postfix/certs'
    };
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.CORE_API_URL+"/postelf-core",{cmd:"createFolder",data:config},{headers});
    return ret;
  }
  
  testWriteFile()
  {
    const config={
      path: '/etc/postfix/certs/server.csr',
      content:"aaaaaaaaaaaddddddddddsssssssss"
    };
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.CORE_API_URL+"/postelf-core",{cmd:"writeFile",data:config},{headers});
    return ret;
    
  }
  
  testRestartService(){
    const config={
      service: 'saslauthds'
    };
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.CORE_API_URL+"/postelf-core",{cmd:"restartService",data:config},{headers});
    return ret;
  }
  
  testStartCore(){
    const config={
      
    };
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"startCoreService",data:config},{headers});
    return ret;
  }
  
  testDependencyMock()
  {
    
    const config={
      
      
    };
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.put(this.API_URL+"/wizard-controller",{cmd:"testDependency",data:config},{headers});
    return ret;
  }
  
  testLogin(){
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let ret=this.httpClient.post(this.API_URL+"/authentication",{"strategy":"local","email":"123@123","password":"123123"},{headers});
    return ret;
  }
  
  testGetUser(){
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    let params = new HttpParams().set("email","123@123").set("$limit","1");
    let ret=this.httpClient.get(this.API_URL+"/users",{headers:headers,params:params});
    return ret;
  }
}
